import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export const DashboardCardSkeleton = () => (
  <div className="p-6 bg-card rounded-lg shadow border">
    <Skeleton className="h-4 w-32 mb-4" />
    <Skeleton className="h-8 w-24 mb-2" />
    <Skeleton className="h-3 w-48" />
  </div>
);

export const TableRowSkeleton = () => (
  <tr>
    {[1, 2, 3, 4].map(i => (
      <td key={i} className="px-4 py-3">
        <Skeleton className="h-4 w-full" />
      </td>
    ))}
  </tr>
);

export const FormSkeleton = () => (
  <div className="space-y-4">
    <div>
      <Skeleton className="h-4 w-24 mb-2" />
      <Skeleton className="h-10 w-full" />
    </div>
    <div>
      <Skeleton className="h-4 w-32 mb-2" />
      <Skeleton className="h-10 w-full" />
    </div>
    <div>
      <Skeleton className="h-4 w-28 mb-2" />
      <Skeleton className="h-24 w-full" />
    </div>
    <Skeleton className="h-10 w-32" />
  </div>
);

export { Skeleton }
